import "../../pages/new/new.scss"
import "../datatable/datatable.scss"
//import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../api/axios';
//import { getAllThesis, getFeedbackById } from '../../services/thesisService';
import {getStudentSelfEvaluation} from '../../services/selfEvaluationService';
import { toast } from 'react-toastify';
import TextBox from './TextBox';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef} from 'react';


export const ViewMonthlyEvaluation = () => {
    const [file, setFile] = useState(null);
  //  const examinerId = parseInt(localStorage.getItem('examinerId'), 10);
    const studentLoginId = parseInt(localStorage.getItem('studentId'), 10);
   // const { feedbackId } = useParams();
    const { studentId } = useParams();
  //  const [thesis, setThesis] = useState([]);
  //  const [students, setStudents] = useState([]);
  //  const [submissions, setSubmissions] = useState([]);
    const [selectedProgress, setSelectedProgress] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [selectedLiterature, setSelectedLiterature] = useState(null);
    const [selectedEffort, setSelectedEffort] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedUpdates, setSelectedUpdates] = useState(null);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [selectedReasons1, setSelectedReasons1] = useState([]);
    const [hasSubmitted, setHasSubmitted] = useState(false); // Track if form is submitted
    const [previousEvaluations, setPreviousEvaluations] = useState([]); // Previous evaluations
    const [evalType, setEvalType] = useState(""); // Selected evaluation type
    const [alreadyDone, setAlreadyDone] = useState(false); // Check if already done
    const [evaluations, setEvaluations] = useState([]); // Store submitted evaluations
    const [loading, setLoading] = useState(false);

    const fileInputRef1 = useRef(null);
    const [evaluation, setEvaluation] = useState({
        studentId: '',
        month: '',
        progress: '', // give name according to table name
        
    });

    const getEvaluations = async (id) => {
        try {
            const response =  await getStudentSelfEvaluation(id);
           // console.log(response.data)
            setEvaluations(response.data);

        } catch (error) {
            console.error('Error fetching instructor:', error);
        }
    };
    const handleLinkClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
      };
    
      const handleFileChange = (event) => {
        setFile(null);
        const selectedFile = event.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB
        const allowedTypes = [
          //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          //'application/vnd.ms-excel', // .xls
          //'text/csv' // .csv
        ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
        //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setFile(selectedFile);
        //}
      };

   // const getEvaluations = () => {
   //     return [
   //       { type: "termiv", data: "Student completed Term IV evaluation" },
   //       { type: "termv_1", data: "Student completed Term V evaluation 1" },
   //     ];
   //   };
      

   // const [examiners, setExaminers] = useState([]);
   // const [selectedExaminerId, setSelectedExaminerId] = useState(null);
   // const [reviewers, setReviewers] = useState([]);
    const [selectedReportType, setSelectedReportType] = useState(null);
  //  const [selectedThesisId, setSelectedThesisId] = useState(null);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const {submissionId} = useParams();
  //  const fetchThesis = async () => {
  //      try {
  //          const data = await getAllThesis();
  //          console.log(data);
  //          setThesis(data.data);
  //      } catch (err) {

   //     }
   // };
    
  /* const fetchSubmission = async (id) => {
    try {
        const response = await axiosInstance.get(`/getEvaluationById?id=${id}`);
        console.log(response.data.data)
        setEvaluation(response.data.data); // Set submission details from API response
    } catch (error) {
        console.error('Error fetching submission:', error);
    }
};*/
    
    const findElementByIdWithReduce = (array, id) => {
      //  console.log(array);
       // console.log(id);
        return array.reduce((acc, element) => {
            return element.id === id ? element : acc;
        }, null);
    };
    const findStudentByEnWithReduce = (array, id) => {
      //  console.log(array);
       // console.log(id);
        return array.reduce((acc, element) => {
            return element.enrollmentNumber === id ? element : acc;
        }, null);
    };

    const findSubmissionsByReportTypeWithReduce = (array, reportType) => {
        return array.reduce((acc, element) => {
            return element.submission_id === reportType ? element : acc;
        }, null);
    };

    const formatColumnData = (value) => {
        if (!value) return value;
    
        // Insert space before each uppercase letter
        let result = value.replace(/([a-z])([A-Z])/g, '$1 $2');
    
        // Capitalize the first letter
        result = result.charAt(0).toUpperCase() + result.slice(1);
    
        return result;
    };
    
    const transformColumnData = (rows) => {
     // console.log(rows)
     // console.log(rows !== '')
        if(rows !== '') {
        return rows.map(row => ({
            ...row,
            type: formatColumnData(row.type), // Only format this column
            overall_feedback : "excellent hai"
        })); }
    };
    const transformedRows = transformColumnData(evaluations);
   // const overall_feedback = "excellent hai";
    const columns = React.useMemo(
        () => [
            { field: 'evalType', headerName: 'Self-Evaluation type', width: 150 },
            {
                field: 'reportLink', headerName: 'Report Link', width: 250, renderCell: (params) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Link
                      href={params.value}
                      onClick={(event) => handleLinkClick(params.value, event)}
                      style={{
                        color: 'blue',
                        textDecoration: 'underline',
                        marginRight: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      {params.value}
                    </Link>
                  </div>
                ),
              },
            { field: 'overall_feedback', headerName: 'Feedback', width: 250 }
        ],
        []
    );
    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/student/monthly-evaluation/view-evaluation/${studentId}/${id}`}} style={{textDecoration:"none"}}>View</Link></div>                    
                </div>
            );
        }
    }]

   // if (loading) return <p>Loading...</p>;
   // if (error) return <p>Error: {error.message}</p>;

 /*  useEffect(() => {
    if (submissionId) {
        const path = window.location.pathname;
        if (path.includes('edit-submission')) {
            setEditMode(true);
        }
        else if (path.includes('view-submission')) {
            setViewMode(true);
        }
        fetchSubmission(submissionId);
        // Set mode to edit if submissionId is present
    } else {
        setEditMode(false); // Set mode to add if no submissionId is present
        setViewMode(false);
    }
   // const existingEvaluations = getEvaluations(studentLoginId);
   // setEvaluations(existingEvaluations);

}, [submissionId]);

*/
    useEffect(() => {
        // Load existing evaluations when the component mounts
        const existingEvaluations = getEvaluations(studentLoginId);
       // setEvaluations(existingEvaluations);
       // console.log(evaluations)
      }, []);
    
    

  const handleTypeChange = (event) => {
    const selectedType = event.target.value;
    setEvalType(selectedType);
    
    // Check if this evaluation type has already been done
    const evalFound = evaluations.find((evaluation) => evaluation.type === selectedType);
    setAlreadyDone(!!evalFound);
  };


    const handleProgressChange = async (event) => {

        if (event.target.value !== '') {
              setSelectedProgress(event.target.value);
            //  setSelectedData(event.target.value)
        }
    };

    const handleDataSelectionChange = async (event) => {

        if (event.target.value !== '') {
              setSelectedData(event.target.value)
        }
    };

    const handleLiteratureChange = async (event) => {

        if (event.target.value !== '') {
              setSelectedLiterature(event.target.value)
        }
    };

    const handleEffortChange = async (event) => {

        if (event.target.value !== '') {
              setSelectedEffort(event.target.value)
        }
    };

    const handleStateChange = async (event) => {

        if (event.target.value !== '') {
              setSelectedState(event.target.value)
        }
    };

    

    // Handle Reasons for More/Less Effort (multiselect)
    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
    
        if (checked) {
          // Add selected reason
          setSelectedReasons((prevReasons) => [...prevReasons, value]);
        } else {
          // Remove unselected reason
          setSelectedReasons((prevReasons) => prevReasons.filter((reason) => reason !== value));
        }
      };
      const handleSelectChange = (event) => {
      const selectedOptions = Array.from(event.target.selectedOptions).map(option => option.value);
    setSelectedReasons1(selectedOptions);
  };

    const handleUpdatesChange = async (event) => {

        if (event.target.value !== '') {
              setSelectedUpdates(event.target.value)
        }
    };
    

    const goBack = (e) => {
       // console.log(feedbackId);
      //  console.log(studentId);
        const path = window.location.pathname;
      //  console.log(path);
        if (studentId)
            navigate(`/examiner/view-feedbacks/${studentId}`);
        else if(studentLoginId)
            navigate(`/student/feedbacks`);
        else if (studentId)
            navigate(`/students/edit-student/${studentId}`);
        else
            navigate('/feedbacks');
    };

    
    const handleClick = (e) => {
       // console.log("inside handle click")
        if(e.target.value)
        window.open(e.target.value, '_blank');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
       // console.log(e.target.value);
      //  console.log(e.target.name);
      //  setFeedback({ ...feedback, [name]: value || '' });
        setErrors({ ...errors, [name]: '' });
    };

    const validateForm = () => {
      const newErrors = {};
    //  if(!editMode && !viewMode){
   //       if (!file ) {
    //          newErrors.reportLink = 'Report File is required';
    //        }
        
    //  }
      
   //   setErrors(newErrors);
   //   return Object.keys(newErrors).length === 0;
  };

    const handleSubmit = async (e) => {
        e.preventDefault();
      //  if (!validateForm()) return;

       // console.log("inside submit");
        var response = '';
        try {         
          setLoading(true);
        //    if (viewMode) {
        //        navigate('/monthly-evaluation');
         //   }
              //  console.log(evaluation);
                var addEvaluation = {
                    studentId: parseInt(localStorage.getItem('studentId'),10),
                    overall: selectedProgress,
                    dataSelection : selectedData,
                    literature : selectedLiterature,
                    effort : selectedEffort,
                    satisfaction : selectedState,
                    updates : selectedUpdates,
                    reasons : selectedReasons1,
                    evalType : evalType,
                    dateSubmitted: new Date(),
                    reportLink : evaluations.reportLink,
                }
                  // take help from StudentSubmission.jsx, line 140 onwards
                  const formData = new FormData();
                  formData.append('submissionData', JSON.stringify(addEvaluation));
                  formData.append('reportFile', file);
                 // console.log(addEvaluation)
                //response = await axiosInstance.post('/selfevaluation', addEvaluation, { showToastOnResponse: true });
                 response = await axiosInstance.post('/selfevaluation1', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  },
                  params: { isUpload: true },
                  showToastOnResponse: true });
            
            //console.log(response);
            //navigate('/feedbacks');

        } catch (error) {
            console.log('Error saving self evaluation. Please try again later.');
            console.log(error);
        }finally {
          setLoading(false);
      }
    };

    return (
        <div>
                     {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
            <div className="top">
                <h1>{editMode ? 'Edit Feedback' : viewMode ? 'View Feedback' : 'Self Evaluation'}</h1>
            </div>
      {/* Dropdown for selecting evaluation type */}
      <div className="top">
      <div className="left"></div>
      <div className="right">
        <label htmlFor="evalType">Select Evaluation Type:</label>
        <select id="evalType" value={evalType} onChange={handleTypeChange}>
          <option value="" disabled>
            -- Select Evaluation Type --
          </option>
          <option value="termiv">Term IV Self-evaluation </option>
          <option value="termv_1">Term V Self-evaluation 1</option>
          <option value="termv_2">Term V Self-evaluation 2</option>
          <option value="termvi_1">Term VI Self-evaluation 1</option>
          <option value="termvi_2">Term VI Self-evaluation 2</option>
        </select>
      {/*</div> */}
           {/* <div className="bottom"> */}
                
                     {/* Display message if already done */}
                     {evalType && alreadyDone && <p>Evaluation already done for {evalType}.</p>}
                     {evalType && !alreadyDone && (

     
                    <form onSubmit={handleSubmit}>
                    <div className="formInput">
                        
                            <label>Project Progress (overall)</label>
                            <select onChange={handleProgressChange}
                                disabled={viewMode || editMode}
                                name="overall"
                                value={selectedProgress}

                            >

                                <option value="Excellent">Ahead of plan</option>
                                <option value="Good">On track</option>
                                <option value="Fair">A little behind plan</option> 
                                <option value="Poor">Far behind plan</option> 
                                                               
                            </select>
                           </div>
                           <div className="formInput">
                            <label>Data Selection and Understanding </label>
                            <select onChange={handleDataSelectionChange}
                                disabled={viewMode || editMode}
                                name="dataSelection"
                                value={selectedData}

                            >

                                <option value="Excellent">Dataset has been analyzed, cleaned and curated to fit project needs, and augmented if needed</option>
                                <option value="Good">Dataset has been explored and analyzed to determine fit to project needs</option>
                                <option value="Fair">Dataset selected, not yet explored and analyzed for suitability to project needs</option> 
                                <option value="Poor">Dataset not yet finalized</option> 
                                                               
                            </select>
                            </div>
                           <div className="formInput">
                           
                            <label>Literature Survey </label>
                            <select onChange={handleLiteratureChange}
                                disabled={viewMode || editMode}
                                name="literature"
                                value={selectedLiterature}

                            >

                                <option value="Excellent">Relevant papers have ben used to shape and guide the project work, and position it relative to the state of the art</option>
                                <option value="Good">Have found relevant papers and have read most of them</option>
                                <option value="Fair">Found some relevant papers, reading them is still in progress</option> 
                                <option value="Poor">Few or no papers identified so far, not yet read</option> 
                                                               
                            </select>
                            </div>
                           <div className="formInput">
                           
                            <label>Efforts this month</label>
                            <select onChange={handleEffortChange}
                                disabled={viewMode || editMode}
                                name="effort"
                                value={selectedEffort}

                            >

                                <option value="Excellent">Worked exceptionally hard</option>
                                <option value="Good">Substantial efforts</option>
                                <option value="Fair">A bit less than planned / preferred</option> 
                                <option value="Poor">Was unable to get much work done</option> 
                                                               
                            </select>
                            </div>
                           <div className="formInput">
                           
                            <label>Satisfaction with overall state of project</label>
                            <select onChange={handleStateChange}
                                disabled={viewMode || editMode}
                                name="satisfaction"
                                value={selectedState}

                            >

                                <option value="Excellent">Project going even better than expected, significantly good outcomes</option>
                                <option value="Good">Project going well, on track to deliver as per plans and expectations</option>
                                <option value="Fair">Some problems with progress/results, but can be handled</option> 
                                <option value="Poor">Project not going well, need to address problem situations</option> 
                                                               
                            </select>
                            </div>
                           <div className="formInput">
                           
                            <label>Updates to proposal</label>
                            <select onChange={handleUpdatesChange}
                                disabled={viewMode || editMode}
                                name="updates"
                                value={selectedUpdates}

                            >

                                <option value="Excellent">There was no feedback to change the proposal</option>
                                <option value="Good">discussed feedback with mentor and updated proposal according to feedback</option>
                                <option value="Fair">discussed with mentor and changes are in progress</option> 
                                <option value="Poor">could not discuss with mentors to reflect the feedback</option> 
                                                               
                            </select>
                            </div>
                           <div className="formInput">
                           
                            <label>Reasons for more/less effort (select all applicable)</label>
                            <select
                            multiple
                            value={selectedReasons1}
                            onChange={handleSelectChange}
                            name='reasons'
                            disabled={viewMode || editMode} // Adjust according to your viewMode/editMode
                            >
                            <option value="Enthusiasm">Enthusiasm</option>
                            <option value="Catching up">Catching up</option>
                            <option value="Planning/estimation gaps">Planning/estimation gaps</option>
                            <option value="Other commitments">Other commitments</option>
                            </select>
                            
                           
       
                         {/*{errors.student && <div className="error-text">{errors.student}</div>}*/}
                        </div>
                        
                        <div className="formInput">
              Upload Presentation File {' '}
              <input type="file" name="reportLink" ref={fileInputRef1} onChange={handleFileChange} />
              {evaluations.reportLink && (
                                <div>
                                    <a href={evaluations.reportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Presentation Link
                                    </a>
                                </div>
                            )}
              {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
            </div>
                        

                        <div className="buttons">
                           {!viewMode && <button type="submit">{editMode ? 'Update' : 'Save'}</button>}
                            <button onClick={goBack}>Back</button>
                        </div>
                    </form>
      )}
                </div>
            </div>
              {/* Display previously submitted evaluations */}
              <div className="top">
      
      </div>
        </div>
    );
};


